import { handleActions } from 'redux-actions';
import * as actions from './ToastMessengerActions';

const initialState = {
  messages: [],
};

export default handleActions(
  {
    [actions.pushMessage]: (state, { payload }) => ({
      ...state,
      messages: [payload, ...state.messages],
    }),

    [actions.popMessage]: state => ({
      ...state,
      messages: state.messages.slice(1),
    }),
  },
  initialState,
);
